// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"f92df3dfe1a8bae3","9777":"bc4e92cd9137eaab"}[chunkId] + ".js";
};